import { render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";

import { ToolComposingIndicator } from "./ToolComposingIndicator";

describe("ToolComposingIndicator", () => {
  it("formats trusted tool labels and the voice request label", () => {
    const { rerender } = render(
      <ToolComposingIndicator label="Searching documents" />,
    );
    expect(screen.getByRole("status")).toHaveTextContent(
      "Preparing: Searching documents…",
    );

    rerender(<ToolComposingIndicator label="your request" />);
    expect(screen.getByRole("status")).toHaveTextContent(
      "Preparing your request…",
    );
  });

  it("uses generic Working when no specific label is available", () => {
    render(<ToolComposingIndicator label="Working" />);
    expect(screen.getByRole("status")).toHaveTextContent("Working...");
  });
});
